import { useCallback } from 'react';
import type { WrapperFC } from '@george-labs.com/design-system';
import { Flag, Inline, Select } from '@george-labs.com/design-system';

import { getFeatureConfig } from '@luna/feature-config';

import { getFlagDataUrlForCurrency } from '../flags/FlagsService';
import { getLocalizedCurrencyName } from './CurrencySelectService';

interface Props {
    value?: string;
    placeholder: string;
    currencies: string[];
    onSelect(currency: string): void;
    fullWidth?: boolean;
}

export const CurrencySelect: WrapperFC<Props> = ({
    value = getFeatureConfig((config) => config.base.defaultCurrency),
    placeholder,
    onSelect,
    currencies,
    fullWidth,
}) => {
    const handleSelect = useCallback((item: any) => onSelect(item.value), [onSelect]);

    return (
        <Select
            fullWidth={fullWidth}
            placeholder={placeholder}
            data-cy="currency-select"
            value={value}
            onSelect={handleSelect}
            className="d-inline-flex"
            itemToString={(item) => item.value}
            items={currencies.map((currency) => ({
                value: currency,
                label: (
                    <>
                        <Flag imageUrl={getFlagDataUrlForCurrency(currency)} />
                        <Inline className="sr-only">{getLocalizedCurrencyName(currency)}</Inline>
                        <Inline aria-hidden="true">{currency}</Inline>
                    </>
                ),
            }))}
        />
    );
};

CurrencySelect.wrapsComponent = Select;
